import React, { forwardRef, useRef } from "react";
import makeStyles from '@mui/styles/makeStyles';
import swal from "sweetalert";
import {
  TextField,
  Grid,
  FormControl,
  Typography,
  Card,
  CardContent,
  Radio,
} from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as api from "../../../actions/api";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";
import { DeleteOutline, Edit, ViewList } from "@mui/icons-material";
//Import Preloader
import LoadingSpinnerOpaque from "services/LoadingSpinnerOpaque";
import encryptionService from "../../../services/encryptionService";

const MOSRange = (props) => {
  const permissionType = props.permissionType;
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "mos-range";
  const UserInfo = encryptionService.decryptUserInfo();
  const UserName = UserInfo == 0 ? "" : UserInfo[0].name;

  const classes = useStyles();
  const tblRefHolder = useRef({ table: null });
  const tblRef = tblRefHolder.current;
  const tableRef = useRef();
  const { useState } = React;

  const assignedProdGroupList = UserInfo[0].ItemGroupId.split(",");
  const [prodGroupCountUnderRole, setProdGroupCountUnderRole] = React.useState(
    assignedProdGroupList.length
  );
  const RoleItemGroupId = UserInfo == 0 ? "" : assignedProdGroupList[0];
  const ProductGroupList = JSON.parse(localStorage.getItem("ProductGroupList"));
  const [currProductGroupId, setCurrProductGroupId] = useState(RoleItemGroupId);

  const [firstLoad, setFirstLoad] = useState(true);


  const [dataItems, setDataItems] = useState([]);

  const { t, i18n } = useTranslation();
  const queryClient = useQueryClient();
  const [isLoading, setLoading] = useState(false);
  
  const handleProductGroupChange = (event, newValue) => {
    let rowId = "";
    if (newValue == null) {
      rowId = "";
    } else {
      rowId = newValue.id;
    }

    if (currProductGroupId !== rowId){
      setFirstLoad(true);
      setLoading(true);
    }

    setCurrProductGroupId(rowId);

  };


  /* const { isLoading3, error, isError, data, refetch } = useQuery(["mosrange"],
    api.getMOSRanges,
    {
      onSuccess: (data) => {

        if (firstLoad) {
          setDataItems(data);
          setLoading(false);
          setFirstLoad(false);
        }

       
      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0, //1000 * 60 * 60 * 24,
    }
  ); */

  let params = {
    menukey: menukey,
    action: "getDataList",
    ItemGroupId: currProductGroupId,
    page_limit: JSON.stringify(100),
    page_number: JSON.stringify(0 + 1),
    search_key: "",
  };


  const {
    error,
    isError,
    data,
    refetch: mosData,
  } = useQuery(
    [params],
    api.getMOSRanges,
    {
      onSuccess: (data) => {
        if (firstLoad) {
          setDataItems(data);
          setLoading(false);
          setFirstLoad(false);
        }
      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0, //1000 * 60 * 60 * 24,
    },
    {
      refetchOnWindowFocus: false,
      enabled: true,
    }
  );

  const { mutate: deleteApi } = useMutation(api.deleteMOSRange, {
    onSuccess: (data) => {
      if (data.data.status == 200) {
        //refetch();
        mosData();
        queryClient.getQueriesData("mosrange");
        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: data.data.success,
        });
      } else {
        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: data.data.success,
        });
      }
    },
  });

  /* =====Start of Excel Export Code==== */
  const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

  const PrintPDFExcelExportFunction = (reportType) => {
    let finalUrl = EXCEL_EXPORT_URL + "report/print_pdf_excel_server.php";

    let currProductGroupName=(ProductGroupList.find(ProductGroup_List => ProductGroup_List.id == currProductGroupId) ?? null).name;


    window.open(
      finalUrl +
        "?action=MOSRangeExport" +
        "&reportType=" +
        reportType +
        "&menukey=" +
        menukey +
        "&ItemGroupId=" +
        currProductGroupId +
        "&ProductGroupName=" +
        currProductGroupName +
        "&lan=" +
        localStorage.getItem("LangCode") +
        "&TimeStamp=" +
        Date.now()
    );
  };
  /* =====End of Excel Export Code==== */

  const tableRowDoubleClick = (e, row) => {
    let rowData = row._row.data;
    editMOSRange(rowData);
  };

  const columns = [
    { title: "Id", field: "id", visible: false },
    {
      title: t(DispensingLanguage[lan][menukey]["Sl#"]),
      hozAlign: "center",
      width: 120,
      formatter: "rownum",
      headerHozAlign: "center",
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["MOS Type"]),
      headerFilter: true,
      field: "MosTypeName",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Minimum MOS"]),
      hozAlign: "center",
      headerHozAlign: "center",
      width: 200,
      field: "MinMos",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Maximum MOS"]),
      hozAlign: "center",
      headerHozAlign: "center",
      width: 200,
      field: "MaxMos",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Color Code"]),
      width: 200,
      field: "ColorCode",
      formatter: "color",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["MOS Label"]),
      width: 200,
      field: "MosLabel",
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Actions"]),
      field: "custom",
      hozAlign: "center",
      width: 120,
      headerHozAlign: "center",
      headerSort: false,
      formatter: reactFormatter(<ActionButton />),
    },
  ];

  const editMOSRange = (data) => {
    let route = `mos-range/edit/${data.id}`;
    props.history.push(route);
  };

  const deleteMOSRange = (data) => {
    swal({
      title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
      text: t(
        DispensingLanguage[lan][menukey][
          "Once deleted, you will not be able to recover this Record!"
        ]
      ),
      icon: "warning",
      buttons: [
        t(DispensingLanguage[lan][menukey]["No"]),
        t(DispensingLanguage[lan][menukey]["Yes"]),
      ],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteApi({
          MosTypeId: data.id,
          menukey: menukey,
          lan: lan,
          UserName: UserName,
          action: "dataDalete",
        });
      }
    });
  };

  function ActionButton(props: any) {
    const rowData = props.cell._cell.row.data;
    const cellValue = props.cell._cell.value || "Edit | Show";

    if (permissionType)
      return (
        <>
          <ViewList
            onClick={() => {
              editMOSRange(rowData);
            }}
          />
        </>
      );
    else
      return (
        <>
          <Edit
            onClick={() => {
              editMOSRange(rowData);
            }}
          />
          {/* <DeleteOutline
            onClick={() => {
              deleteMOSRange(rowData);
            }}
          /> */}
        </>
      );

    /* return (
      <>
        <Edit
          onClick={() => {
            editMOSRange(rowData);
          }}
        />
        <DeleteOutline
          onClick={() => {
            deleteMOSRange(rowData);
          }}
        />
      </>
    ); */
  }

  React.useEffect(() => {
    setLoading(true);
    mosData();
  }, []);


  return (
    <>
      <div className={classes.mosrangePageTitle}>
        <div className="d-flex justify-mosrange mb-2">
          <Grid container>
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading">
              <div className="sw_heading_title">
                {DispensingLanguage[lan][menukey]["MOS Range"]}{" "}
              </div>
            </div>
          </Grid>
          </Grid>
        </div>

        {/* start of filter */}
        <Card className="sw_card sw_filter_card">
          <CardContent className="sw_filterCardContent">
            <Grid container spacing={1}>
              <Grid item xs={2} sm={2}>
                <FormControl className={classes.fullWidth}>
                  <Autocomplete
                    autoHighlight
                    className="sw_chosen_filter"
                    id="ProductGroupList"
                    disableClearable
                    //disabled={userId == 1 ? false : true}
                    disabled={prodGroupCountUnderRole > 1 ? false : true}
                    options={ProductGroupList}
                    onChange={(event, newValue) =>
                      handleProductGroupChange(event, newValue)
                    }
                    getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                      value={
                      (ProductGroupList.find(
                          (productGroupList) =>
                            productGroupList.id == currProductGroupId
                        ) ?? null)
                    }
                    renderOption={(props, option) => (
                      <li {...props} key={option.id ?? option.name}>
                        <Typography className="sw_fontSize">{option.name}</Typography>
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          DispensingLanguage[lan][menukey]["Product Group"]
                        }
                        variant="standard"
                        hiddenLabel
                      />
                    )}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={10} sm={10}>
                <div className="float-end sw_btn_control">
                  {/* <Button
                    disabled={!!props.permissionType}
                    color="info"
                    className="me-2"
                    onClick={() => {
                      props.history.push("/mos-range/add");
                    }}
                  >
                    {DispensingLanguage[lan][menukey]["Add MOS Range"]}
                  </Button> */}
                  <Button
                    color="info"
                    className="me-2 sw_icons"
                    onClick={() => PrintPDFExcelExportFunction("print")}
                  >
                    <i className="fas fa-print"></i>
                  </Button>

                  <Button
                    color="info"
                    className="me-2 sw_icons"
                    onClick={() => PrintPDFExcelExportFunction("excel")}
                  >
                    <i className="far fa-file-excel"></i>
                  </Button>
                </div>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        {/* end of filter */}

        <div className="sw_relative">
          {isLoading && <LoadingSpinnerOpaque />}

          <div className="uniqueName">
            <ReactTabulator
              onRef={(r) => { tblRef.table = r.current; }}
              columns={columns}
              data={dataItems}
              //height={600}
              layout={"fitColumns"}
              events={{
                rowDblClick: (e, row) => tableRowDoubleClick(e, row),
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default MOSRange;

const useStyles = makeStyles({
  mosrangePageTitle: {
    marginTop: "60px",
    color: "white",
    background: "whitesmoke",
    color: "black",
    borderRadius: "10px",
    padding: "1rem",
  },
  tableContainer: { backgroundColor: "whitesmoke", borderRadius: "10px" },
  fullWidth: {
    width: "95%",
  },
  filterDiv: {
    width: "80%",
    display: "flex",
  },
});
